import {BaseMixins} from '../component/base-mixins'
import {Component} from '../component/decorator';
@Component
export class PageResultModalMixins extends BaseMixins {

    /**
     * 打开新增Modal
     * @param ref 默认 create-modal
     */
    create(ref:string = "create-modal"){
        this.open(ref);
    }

    /**
     * 打开编辑Modal
     * @param ref 默认 edit-modal
     */
    edit(ref:string = "edit-modal"){
        this.open(ref);
    }

    /**
     * 打开详情Modal
     * @param ref 默认 detail-modal
     */
    detail(ref:string = "detail-modal"){
        this.open(ref);
    }

    /**
     * 打开模态框
     * @param ref  Modal ref name
     */
    open(ref:string){
        (this.$refs[ref] as any).open();
    }

    /**
     * 编辑按钮 permission默认页面权限 + .Edit
     * @param check 业务逻辑验证
     * @param type dispatchType 默认 module/menu/edit(路由name)
     * @param ref Modal ref name
     */
    colEditBtnM(check?:Function, type?:string, ref?:string){
        return {
            label: "Action.Edit",
            permission: this.$route.meta.access[0] + ".Edit",
            check:check,
            callback:row => {
                if(type){
                    this.$store.commit(type, row);
                }else{
                    let commitType = this.getCommitTypePrefix() + "/edit";
                    this.$store.commit(commitType, row);
                }
                this.edit(ref);
            }
        }
    }

    /**
     * 详情按钮 permission默认页面权限 + .Detail
     * @param check 业务逻辑验证
     * @param type dispatchType 默认 module/menu/edit(edit)
     * @param ref Modal ref name
     */
    colDetailBtnM(check?:Function, type?:string,  ref?:string){
        return {
            label: "Action.Detail",
            permission:this.$route.meta.access[0] + ".Detail",
            check:check,
            callback:row => {
                if(type){
                    this.$store.commit(type, row);
                }else{
                    let commitType = this.getCommitTypePrefix() + "/edit";
                    this.$store.commit(commitType, row);
                }
                this.detail(ref);
            }
        }
    }

    /**
     * 公共按钮
     * @param label 多语言key
     * @param permission 权限
     * @param type commit type
     * @param ref Modal ref name
     * @param callback 自定义回调
     * @param check 业务逻辑验证
     */
    colCommonBtnM(label:string,permission:string, type:string, ref: string, callback?:Function, check?:Function){
        return {
            label: label,
            permission:permission,
            check:check,
            callback:row => {
                if(callback){
                    callback(row);
                }else{
                    this.$store.commit(type, row);
                }
                this.open(ref);
            }
        }
    }

    /**
     * 获取commitType 前缀
     */
    getCommitTypePrefix(){
        let length = this.$route.matched.length;
        let commitType = this.$route.matched[length-2].name + "/" + this.$route.matched[length-1].name;
        if(this.$route.meta.hideInMenu){
            commitType = this.$route.matched[length-3].name + "/" + this.$route.matched[length-2].name;
        }
        return commitType;
    }
}